"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SetupCenter = _interopRequireDefault(require("./components/SetupCenter.vue"));
var _IncomeDetailModule = _interopRequireDefault(require("./components/IncomeDetailModule.vue"));
var _OrderModuleSetup = _interopRequireDefault(require("./components/OrderModuleSetup.vue"));
var _InvitationSharingModule = _interopRequireDefault(require("./components/InvitationSharingModule.vue"));
var _LeaderboardPageManagement = _interopRequireDefault(require("./components/LeaderboardPageManagement.vue"));
var _SearchPageSettings = _interopRequireDefault(require("./components/SearchPageSettings.vue"));
var _invitationCodeModule = _interopRequireDefault(require("./components/invitationCodeModule.vue"));
var _positive_review_settings = _interopRequireDefault(require("./components/positive_review_settings.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SecondaryPageSetup',
  components: {
    SetupCenter: _SetupCenter.default,
    IncomeDetailModule: _IncomeDetailModule.default,
    OrderModuleSetup: _OrderModuleSetup.default,
    InvitationSharingModule: _InvitationSharingModule.default,
    LeaderboardPageManagement: _LeaderboardPageManagement.default,
    SearchPageSettings: _SearchPageSettings.default,
    invitationCodeModule: _invitationCodeModule.default,
    positive_review_settings: _positive_review_settings.default
  }
};